import type {
  CSVData,
  CSVDataSourceID,
  DataSourceID,
  ExperimentDataSourceID,
  ExperimentsDataSource,
  GEMDDataSourceID,
  SnapshotDataSource,
  SnapshotDataSourceID,
  TableData,
  TrainingData,
} from "./data-source";

export function parseDataIdentifier(id: CSVDataSourceID): CSVData;
export function parseDataIdentifier(
  id: ExperimentDataSourceID
): ExperimentsDataSource;
export function parseDataIdentifier(id: GEMDDataSourceID): TableData;
export function parseDataIdentifier(
  id: SnapshotDataSourceID
): SnapshotDataSource;
export function parseDataIdentifier(id: string): TrainingData | undefined;
export function parseDataIdentifier(id: string): TrainingData | undefined {
  const [type, term1, term2] = id.split("::");
  switch (type) {
    case "csv":
      return {
        type: "csv_data_source",
        file_link: {
          type: "file_link",
          url: term1,
          filename: term2,
        },
        column_definitions: {},
      };
    case "experiments":
      return {
        type: "experiments_data_source",
        id: term1,
      };
    case "gemd":
      return {
        type: "hosted_table_data_source",
        table_id: term1,
        table_version: Number(term2),
      };
    case "snapshot": {
      return {
        type: "snapshot_data_source",
        snapshot_id: term1,
      };
    }
  }
}

export function getDataIdentifier(data: CSVData): CSVDataSourceID;
export function getDataIdentifier(
  data: ExperimentsDataSource
): ExperimentDataSourceID;
export function getDataIdentifier(data: TableData): GEMDDataSourceID;
export function getDataIdentifier(
  data: SnapshotDataSource
): SnapshotDataSourceID;
export function getDataIdentifier(data: TrainingData): DataSourceID;
export function getDataIdentifier(data: TrainingData): DataSourceID {
  switch (data.type) {
    case "csv_data_source":
      return `csv::${data.file_link.url}::${data.file_link.filename}`;
    case "experiments_data_source":
      return `experiments::${data.id}`;
    case "hosted_table_data_source":
      return `gemd::${data.table_id}::${data.table_version}`;
    case "snapshot_data_source":
      return `snapshot::${data.snapshot_id}`;
  }
}
